module.exports = __webpack_public_path__ + "img/apple_store_badge_fr.2cfdd0a7.svg";